import type { Translations } from './types';
import en from './en';
import es from './es';

export type { Translations };

// Brand names that should render the Spanish UI.
// Add new Spanish brand names to this set as they are created.
export const SPANISH_BRANDS = new Set<string>([
  'empeno'
]);

export const getTranslations = (brand: string | null): Translations => {
  const normalizedBrand = brand?.toLowerCase().trim() ?? '';
  return SPANISH_BRANDS.has(normalizedBrand) ? es : en;
};
